import { __rest } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/swiper/core/core.js';
import '../../../../../node_modules/swiper/shared/dom.js';
import Navigation from '../../../../../node_modules/swiper/modules/navigation/navigation.js';
import Pagination from '../../../../../node_modules/swiper/modules/pagination/pagination.js';
import { renderCustomSwiperNav } from '../../../molecules/carousel-navigation/index.js';

const getInfographicsSettings = (
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_a, ctx) => {
    __rest(_a, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    []);
    return ({
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: ctx._nextBtn,
            prevEl: ctx._prevBtn,
            disabledClass: 'disabled',
        },
        pagination: {
            el: ctx._counter,
            type: 'custom',
            renderCustom: (swiper, current, total) => renderCustomSwiperNav(ctx.navTemplate, current, total),
        },
        a11y: {
            prevSlideMessage: ctx.previousText,
            nextSlideMessage: ctx.nextText,
        },
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 24,
        loop: false,
        breakpoints: {
            850: {
                slidesPerView: 3.3,
            },
            1000: {
                slidesPerView: 3.5,
            },
            1130: {
                slidesPerView: 3.7,
            },
            1230: {
                slidesPerView: 3.8,
            },
            1366: {
                slidesPerView: 4,
            },
        },
    });
};

export { getInfographicsSettings };
